module.exports = __webpack_public_path__ + "static/media/LOGO.45b67cee.png";